import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact,faDocker } from '@fortawesome/free-brands-svg-icons';
import Marquee from "react-fast-marquee";
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "Java",
    "Spring Boot",
    "REST APIs",
    "JSP",
    "JWT Authentication",
    "OAuth2",
    "WebSockets",
    "keycloak",
    "Resilience4j",
    "Microservices architecture",
    "SQL",
    "MongoDB",
    "Redis",
    "Apache Kafka",
    "Stripe Integration",
    "Ai APIs",
    "JUnit",
];

const labelsSecond = [
    "Git",
    "CI/CD",
    "Docker🐋",
    "AWS",
    "Ubuntu",
    "Ansible Automation",
    "Terraform",
    "Kubernetes🦑",
    "RabbitMQ",
];

const labelsThird = [
    "React",
    "JavaScript",
    "TypeScript",
    "Html5",
    "Css3",
    "Tailwind",
    "Postman",
    "Figma",
];

function Expertise() {
    return (
    <div className="container" id="expertise">
 
        <div className="skills-container">
             <div className="section-title">
                  <span className="line"></span>
                  <h2>
                    EXPERTISE <span>/ Build stack</span>
                  </h2>
                </div>
            <div className="skills-grid">
                <div className="skill">
                    <i className="devicon-spring-plain tech-icon"></i>
                    <h3>Backend Development</h3>
                    <p>I build scalable backend systems and APIs using modern technologies. I have strong experience with the full SDLC, from designing system architecture to development, testing, and deployment.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faDocker} size="3x"/>
                    <h3>DevOps & Automation</h3>
                    <p>Once the application is built, I help clients set up DevOps testing, CI/CD pipelines, and deployment automation to support the successful Go-Live.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faReact} size="3x"/>
                    <h3>Frontend Development</h3>
                    <p>Although my main focus is backend engineering, I have solid experience in building modern and responsive frontend interfaces using React, which enables me to work effectively as a full-stack developer when needed.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
            <Marquee speed={40} gradient={false} className="tech-marquee">
        <i className="devicon-java-plain colored tech-icon"></i>
        <i className="devicon-spring-plain colored tech-icon"></i>
        <i className="devicon-docker-plain colored tech-icon"></i>
        <i className="devicon-redis-plain colored tech-icon"></i>
        <i className="devicon-mongodb-plain colored tech-icon"></i>
        <i className="devicon-jenkins-plain colored tech-icon"></i>
        <i className="devicon-amazonwebservices-plain colored tech-icon"></i>
        <i className="devicon-git-plain colored tech-icon"></i>
        <i className="devicon-ubuntu-plain colored tech-icon"></i>
        <i className="devicon-javascript-plain colored tech-icon"></i>
        <i className="devicon-typescript-plain colored tech-icon"></i>
        <i className="devicon-ansible-plain colored tech-icon"></i>
        <i className="devicon-terraform-plain colored tech-icon"></i>
        <i className="devicon-mysql-plain colored tech-icon"></i>
        <i className="devicon-jetbrains-plain colored tech-icon"></i>
        </Marquee>
    </div>
    );
}

export default Expertise;